import {
  ListRecoverRegistrationsInputSchema,
  ListRecoverRegistrationsResultSchema,
} from "@redotech/redo-marketing-templates-common/recover/registration-dashboard";

export const listRecoverRegistrations = {
  name: "listRecoverRegistrations" as const,
  input: ListRecoverRegistrationsInputSchema,
  output: ListRecoverRegistrationsResultSchema,
};
